var _defs, _polygon, _g, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDitoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 787.42 547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2, .cls-6 {\n        fill: #0098cd;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4, .cls-5 {\n        font-size: 448.73px;\n        font-family: Helvetica-Light, Helvetica;\n      }\n\n      .cls-4 {\n        fill: #0098cc;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        font-weight: 300;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        font-size: 39.04px;\n        font-family: HelveticaNeue-Light, Helvetica Neue;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-23.59 -35.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 841.89,
    height: 595.28
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dito-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "506.25 418.35 567.43 395.12 529.48 357.16 506.25 418.35"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811,310.58A143.16,143.16,0,1,1,667.86,167.42,143.16,143.16,0,0,1,811,310.58",
    transform: "translate(-23.59 -35.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 385.45)"
  }, "dit"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(519.63 387.7)"
  }, "o"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(22.31 448.8)"
  }, "Digitales Informations-Tool")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(89.54 495.65)"
  }, "f\xFCr Sprache und Arbeit")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDitoLogo);
export default __webpack_public_path__ + "static/media/ditoLogo.ad1d8d4f2984d03bb46145ec008c73f9.svg";
export { ForwardRef as ReactComponent };